import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Radios from '../../common/Radios';
import Button from '../../common/Button';
import Modal from '../../common/Modal';
import { hideModal, showModal } from '../../../actions/modal';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  confirmSupply,
  editCurrentSupply,
  fetchGetSupplyWorksheet,
  fetchGetSupplyWorksheetFormTemplate,
  fetchSupplyById,
  fetchUpdateSupplyWorksheet,
  setCurrentSupplyConfirmStatus,
  updateSupply,
  updateSupplyFact,
} from '../../../actions/supplies';
import { toast } from 'react-toastify';
import { parseError } from '../../../helpers';
import EditOrLock from '../../Orders/SingleOrderPage/common/EditOrLock';
import Checkbox from '../../common/Checkbox';
import Select from '../../common/Select';
import TextArea from '../../common/TextArea';
import Lock from '../../common/Lock';
import WorksheetBlock from './WorksheetBlock';
import { saveSupply } from './MainPage';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const FieldWrapper = styled('div')`
  .file-type-toggle {
    margin: -10px 0 20px;
  }

  .dropzone {
    display: flex;
    align-items: center;
    padding: 5px;
    min-height: 100px;
    cursor: pointer;
    background-color: #ffffff;
    border: 2px dashed rgba(50, 58, 70, 0.3);

    &.with-text {
      width: 100%;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition-duration: 0.3s;
    }
  }

  .selected-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
    min-height: 100px;
    background-color: #f1f5f7;
    border-radius: 0.2rem;
    position: relative;

    .selected-file-name {
      text-decoration: underline;
    }

    .selected-file-close {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.4rem;
      padding: 5px 10px;
      font-weight: 700;
      line-height: 1;
      color: #000;
      opacity: 0.5;
      cursor: pointer;

      :hover {
        opacity: 1;
      }
    }

    .file-type-toggle {
      margin: -15px 0 20px 0;
    }
  }
`;

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;

  > div,
  > p {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .header-title {
    margin-bottom: 16px;
  }

  .block-subtitle {
    margin-bottom: 8px;
  }

  .card-title {
    padding-top: 4px;
    padding-bottom: 23px;
    align-items: center;
    h4 {
      font-size: 16px;
      margin: 0;
    }
  }

  .file-type-toggle {
    margin: -15px 0 20px 0;
  }

  .fbo-item {
    margin-top: 16px;
  }

  .block-item {
    display: flex;
    flex-direction: column;
  }

  .textarea-wrapper {
    margin-top: 12px;

    textarea {
      resize: none;
    }
  }
`;

export const SUPPLIES_SETTINGS_OPTIONS = [
  {
    label: 'Стандартная приёмка',
    value: 'STANDARD',
  },
  {
    label: 'Нестандартная приёмка',
    value: 'CUSTOM',
  },
];

export const findElementValue = (array, string) => {
  return array.find((item) => item.id === string).title;
};

const Field = (props) => {
  const { id, value, formData } = props;

  const currentField = formData && formData.find((f) => f.id === id);
  const currentValue = value ? value : '';
  const [selectValue, setSelectValue] = useState(null);

  const options = (currentField) => {
    if (currentField.inputType === 'MULTI') {
      return currentField.availableValues?.map((item) => ({ ...item, label: item.title }));
    } else {
      return [];
    }
  };

  const FieldValueComponent = () => {
    if (currentField?.id === 'require_individual_additional_packing') {
      return (
        <Checkbox
          label={'Индивидуальная доп. упаковка товара'}
          checked={currentField?.value}
          disabled
        />
      );
    } else if (currentField?.id === 'use_factory_master_boxes') {
      return <Checkbox checked={currentField?.value} label={currentField.name} disabled />;
    } else if (currentField?.inputType === 'CHECKBOX') {
      return <Checkbox checked={currentValue?.value} label={currentField?.name} disabled />;
    } else if (currentField?.inputType === 'MULTI') {
      return (
        <Select
          id={currentField?.id}
          name={currentField?.name}
          options={options(currentField)}
          value={{
            label: findElementValue(currentField?.availableValues, currentValue?.value),
            value: currentValue?.value,
          }}
          onChange={(e) => setSelectValue(e)}
          disabled
        />
      );
    } else {
      return <div>{currentValue ? currentValue : <i>Данные не заполнены</i>}</div>;
    }
  };

  return (
    <FieldWrapper>
      <div key={id} className="fbo-item">
        <div className="block-subtitle">{props.name}</div>
        <FieldValueComponent />
      </div>
    </FieldWrapper>
  );
};

const AcceptanceSettingsBlock = () => {
  const dispatch = useDispatch();
  const currentSupply = useSelector((state) => state.supplies.currentSupply);
  const { id: supplyId } = useParams();
  const [action, setAction] = useState(currentSupply.takeInType);
  const [unsaved, setUnsaved] = useState(false);
  const [formData, setFormData] = useState([]);
  const [fields, setFields] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const { t } = useAutoTranslation();

  /*  const saveSupply = async (saveFactQuantity) => {
    try {
      await otherBlockRef.current.submitOtherBlock();

      if (isManualSupply) {
        await dispatch(setCurrentSupplyConfirmStatus('APPROVED'));
      }

      const id = await dispatch(updateSupply(supplyCustomId));
      if (isManualSupply && (quantityFactChange || saveFactQuantity)) {
        try {
          await dispatch(updateSupplyFact());
        } catch (error) {
          console.error(error);
          toast.error(`Ошибка обновления фактического количества товара`);
        }
      }
      const savedSupply = await dispatch(fetchSupplyById(id));
      setQuantityFactChange(false);
      setSaveLoading(false);
      //Здесь supplyId пока из рутера. Поскольку мы рока не меняли роут он еще пустой если запись добавлена
      if (!supplyId) {
        history.replace(`/supplies/${savedSupply.id}`);
      }
    } catch (err) {
      //toast.error(parseError(err));
      throw err;
    }
  };*/

  useEffect(() => {
    dispatch(fetchGetSupplyWorksheetFormTemplate(currentSupply.id)).then((res) => {
      setFormData(res.form_content);
    });
    dispatch(fetchGetSupplyWorksheet(currentSupply.id)).then((res) => {
      setFields(res);
    });
  }, [currentSupply]);

  useEffect(() => {
    loading && setAction(currentSupply.takeInType);
  }, [currentSupply.takeInType]);

  const openWorksheetModal = () => {
    dispatch(
      showModal('EditSupplysheetModal', {
        fields,
        formData,
        handleSave: async ({ values, comments }) => {
          await dispatch(
            fetchUpdateSupplyWorksheet({
              orderId: currentSupply.id,
              form_content: formData.map((f) => ({
                ...f,
                value: values[f.id],
                comment: comments[f.id],
              })),
            }),
          )
            .then((newData) => {
              setFormData(newData);
            })
            .then(() => {
              setLoading(true);
              setIsVisible(false);
              dispatch(fetchSupplyById(currentSupply.id));
              dispatch(updateSupply(currentSupply.id));
              toast.info('Анкета приемки успешно обновлена');
              setLoading(false);
              setIsVisible(true);
            })
            .catch((err) => {
              toast.error(parseError(err));
            });
        },
      }),
    );
  };

  const handleChange = (e) => {
    if (e === 'CUSTOM') {
      setIsVisible(true);
      dispatch(
        editCurrentSupply({
          ...currentSupply,
          takeInType: e,
        }),
      );
      setAction(e);
    } else {
      setLoading(true);
      setIsVisible(false);

      dispatch(
        editCurrentSupply({
          ...currentSupply,
          takeInType: e,
        }),
      );

      dispatch(fetchSupplyById(currentSupply.id));
      dispatch(updateSupply(currentSupply.id));
      /*      dispatch(updateSupplyFact());*/
      setAction(e);
      toast.info('Анкета приемки успешно обновлена');
      setLoading(false);
    }
  };

  return (
    <>
      {formData && formData.length !== 0 && (
        <Wrapper className="card-box">
          <div>
            <div style={{ display: 'flex' }}>
              <h4 className="header-title">{t('Анкета Приемки')}</h4>
              {unsaved || (
                <>
                  {currentSupply.takeInType &&
                  currentSupply.takeInType !== 'STANDARD' &&
                  (currentSupply.status === 'NEW' ||
                    currentSupply.status === 'READY_TO_TAKE_IN') ? (
                    <div
                      className="change-link"
                      style={{ marginLeft: 'auto' }}
                      onClick={openWorksheetModal}
                    >
                      {t('Изменить')}
                    </div>
                  ) : (
                    <div style={{ marginLeft: 'auto' }}>
                      <Lock />
                    </div>
                  )}
                </>
              )}
            </div>
            <Radios
              id="action"
              name="action"
              data={SUPPLIES_SETTINGS_OPTIONS.map((item) => ({
                value: item.value,
                label: t(item.label),
              }))}
              currentValue={action}
              onChange={(e) => handleChange(e)}
              disabled={loading}
            />
            {isVisible && <WorksheetBlock currentSupply={currentSupply} />}
          </div>
        </Wrapper>
      )}
    </>
  );
};

export default AcceptanceSettingsBlock;
